import { sampleLabel } from './sampleLabel';

import './ReferenceLabel.scss';

export const ReferenceLabel = sampleLabel('wdk-ReferenceLabel');
